// src/pages/SettingsPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import useLicenseCheck from "../hooks/useLicenseCheck";

const SettingsPage = () => {
useLicenseCheck();

  const [settings, setSettings] = useState({
    language: 'en',
    theme_mode: 'light', // light | dark
    font_size: 'medium', // small | medium | large
  });

  const token = localStorage.getItem('token');

  // Fetch settings on load
  useEffect(() => {
    axios.get('https://installmentzone.com/api/get_settings.php', {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => {
      if (res.data.status === 'success') {
        setSettings(res.data.data);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch(() => toast.error('Failed to fetch settings'));
  }, [token]);

  // Handle input changes
  const handleChange = e => setSettings({...settings, [e.target.name]: e.target.value });

  // Update settings
  const updateSettings = async e => {
    e.preventDefault();
    try {
      const res = await axios.post('https://installmentzone.com/api/update_settings.php', settings, {
        headers: { Authorization: `Bearer ${token}` }
      });
      res.data.status === 'success' ? toast.success(res.data.message) : toast.error(res.data.message);
    } catch (err) {
      toast.error('Failed to update settings');
      console.error(err);
    }
  };

  return (
    <div className="p-4 max-w-xl mx-auto space-y-6">
      <h2 className="text-2xl font-bold mb-4">Settings</h2>

      <form onSubmit={updateSettings} className="space-y-4">
        {/* Language */}
        <div>
          <label className="block font-medium mb-1">Language</label>
          <select name="language" value={settings.language} onChange={handleChange} className="input">
            <option value="en">English</option>
            <option value="fr">French</option>
            <option value="es">Spanish</option>
            <option value="de">German</option>
          </select>
        </div>

        {/* Theme Mode */}
        <div>
          <label className="block font-medium mb-1">Theme</label>
          <select name="theme_mode" value={settings.theme_mode} onChange={handleChange} className="input">
            <option value="light">Light Mode</option>
            <option value="dark">Dark Mode</option>
          </select>
        </div>

        {/* Font Size */}
        <div>
          <label className="block font-medium mb-1">Font Size</label>
          <select name="font_size" value={settings.font_size} onChange={handleChange} className="input">
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
          </select>
        </div>

        <button type="submit" className="btn-primary mt-2">Update Settings</button>
      </form>
    </div>
  );
};

export default SettingsPage;